import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon, ChevronDownIcon } from "lucide-react";
import type { FaqItem } from "../types/content";
type FaqProps = {
  items: FaqItem[];
  id?: string;
  eyebrow?: string;
  title?: string;
  intro?: string;
  background?: "white" | "soft";
  moreLink?: {
    label: string;
    to: string;
  };
};
export function Faq({
  items,
  id = "faqs",
  eyebrow = "STRAIGHT ANSWERS",
  title = "Rinnai air conditioning questions, answered.",
  intro = "Useful starting points for Perth homeowners comparing systems. Your final recommendation still needs to reflect your home.",
  background = "soft",
  moreLink
}: FaqProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id={id} className={`${background === "soft" ? "bg-soft" : "bg-white"} py-8 lg:py-14`} aria-labelledby={`${id}-title`} data-id="element-63" data-mp="1z59v1dq1ifd3">
      <div className="mx-auto grid max-w-[1320px] gap-10 px-5 lg:grid-cols-[0.65fr_1.35fr] lg:px-10" data-id="element-64" data-mp="nniho17q1l71">
        <div className="max-w-md" data-id="element-65" data-mp="phelq9yhvpj1">
          <p className="text-sm font-bold text-rinnai" data-id="element-66" data-mp="pih762d1szrk">{eyebrow}</p>
          <h2 id={`${id}-title`} className="mt-4 text-3xl font-bold tracking-[-0.04em] sm:text-4xl lg:text-5xl" data-id="element-67" data-mp="uhane2jpz4vf">{title}</h2>
          <p className="mt-5 leading-7 text-muted" data-id="element-68" data-mp="fiytu4rn8c8h">{intro}</p>
          {moreLink && <Link to={moreLink.to} className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-rinnai transition-colors duration-150 ease-out hover:text-rinnaiDark" data-id="element-69" data-mp="khtgjhsqekxv">
              {moreLink.label} <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-70" data-mp="bj83u39xy050" />
            </Link>}
        </div>
        <div className="border-t border-line" data-id="element-71" data-mp="3szzd2499fwpc">
          {items.map((item, index) => {
          const isOpen = openIndex === index;
          const panelId = `${id}-panel-${index}`;
          const buttonId = `${id}-button-${index}`;
          return <div key={item.question} className="border-b border-line" data-id="element-72" data-mp="3o039250kc59s" data-mpi={index}>
                <h3 data-id="element-73" data-mp="1ugum9v8jk9q1">
                  <button id={buttonId} type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-6 py-6 text-left text-lg font-bold text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rinnai focus-visible:ring-offset-2" data-id="element-74" data-mp="1uhcrvih3g0am">
                    {item.question}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-rinnai transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-75" data-mp="28hx9wcf6ps32" />
                  </button>
                </h3>
                {isOpen && <div id={panelId} role="region" aria-labelledby={buttonId} className="max-w-3xl pb-6 pr-10 text-sm leading-7 text-muted" data-id="element-76" data-mp="s2dtb9qrtpdi">
                    {item.answer}
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}